import { HtmlComponent } from '@varo/graphql-schema-types';
import { HTMLComponentProps } from 'shared/components/HTMLRenderer/HTMLComponent/HTMLComponent';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

import { UnknownGQLType } from './genericRouteAction';

export interface HtmlComponentDependencies {
  navigateForAction: (action: Maybe<UnknownGQLType>) => void;
}

const htmlComponent = (
  component: HtmlComponent,
  { navigateForAction }: HtmlComponentDependencies,
): VXLNode => {
  return {
    id: component.id,
    name: VXLComponentId.HTML_COMPONENT,
    props: { ...component, navigateForAction } satisfies HTMLComponentProps,
  };
};

export default htmlComponent;
